import { getWisdomRoute, trackWisdomEvents } from '@modules/oracle/utils';
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { Chat } from 'generated/graphql';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useParseSavedSlugInfo from 'v2/core/services/savedSlug/useParseSavedSlugInfo';
import { WisdomChatListItemMenu } from '../WisdomChatListItemMenu';

interface WisdomSavedChatListItemProps {
  chat: Omit<Chat, 'responses'>;
}

export const WisdomSavedChatListItem = ({
  chat,
}: WisdomSavedChatListItemProps) => {
  const navigate = useNavigate();
  const [isHovering, setIsHovering] = useState(false);
  const { token: viewTokenFromURL } = useParseSavedSlugInfo();

  return (
    <ListItem
      dense
      key={chat.id}
      onClick={() => {
        navigate(
          getWisdomRoute({
            name: chat.title,
            token: chat.viewToken,
          }),
        );

        trackWisdomEvents({
          eventName: 'Wisdom - Chat Opened',
          chatName: chat.title,
        });
      }}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      secondaryAction={
        isHovering && (
          <Box onClick={(eve) => eve.stopPropagation()}>
            <WisdomChatListItemMenu
              chat={chat}
              kebabMenuButtonProps={{
                sx: {
                  visibility: isHovering ? 'visible' : 'hidden',
                },
              }}
              onClose={() => setIsHovering(false)}
            />
          </Box>
        )
      }
      disablePadding
    >
      <ListItemButton selected={viewTokenFromURL === chat.viewToken}>
        <Tooltip title={chat.title} disableInteractive placement="top" arrow>
          <ListItemText
            primary={chat.title}
            primaryTypographyProps={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
          />
        </Tooltip>
      </ListItemButton>
    </ListItem>
  );
};
